import { useState } from "react";
import createAxiosInstanceNew from "../Api/AxiosInstance/AxiosInstance";

export default function useRequest() {
  const initialState = {
    data: null,
    loading: false,
    error: "",
    message: "",
    success: undefined,
  };

  const [response, setResponse] = useState(initialState);

  async function request({
    method,
    endPoint,
    data,
    headers = { "Content-Type": "application/json" },
  }) {
    setResponse((prev) => ({
      ...prev,
      loading: true,
      error: "",
      success: undefined,
    }));

    try {
      const axiosInstance = await createAxiosInstanceNew();

      const res = await axiosInstance[method](endPoint, data, { headers });

      // Manejo de respuesta exitosa
      if (res.status === 200) {
        setResponse({
          data: res.data,
          loading: false,
          error: "",
          message: res.data?.message || "Request successful",
          success: true,
        });
      } else {
        // Manejo de respuesta no exitosa
        setResponse({
          data: null,
          loading: false,
          error: res.data?.message || "Unexpected error occurred",
          message: "",
          success: false,
        });
      }
    } catch (error) {
      // Manejo de errores en caso de excepción
      setResponse({
        data: null,
        loading: false,
        error: error?.response?.data?.message || error.message || "Network error",
        message: "",
        success: false,
      });
    } finally {
      setResponse((prev) => ({ ...prev, loading: false }));
    }
  }

  function resetRequestValues() {
    setResponse(initialState);
  }

  return {
    request,
    resetRequestValues,
    response, // Exponemos todo el estado por si se necesita
    loading: response.loading,
    success: response.success,
    error: response.error,
    message: response.message,
    data: response.data,
  };
}
